import axios from 'axios';

const instance = axios.create({
    baseURL: 'https://burger-builder-f5b21.firebaseio.com'
});

export default instance;